import { useNavigate } from "react-router-dom";
import API_CONFIG from "../../config/api";
import React, { useState, useEffect } from "react";
import authService from "../../services/authService";
import { formatPostTimestamp } from "../../utils/dateTime";

function CardCommunity({id, title, category, category_name, timestamp, views, likes, hasLiked, author, author_id, author_nickname, abstract, featured_image, first_image_url, author_profile_image, space_id, space_title, space_thumbnail}) {
    const navigate = useNavigate();
    const [isLiked, setIsLiked] = useState(hasLiked || false);
    const [likeCount, setLikeCount] = useState(likes || 0);
    const [likeAuth, setLikeAuth] = useState(() => authService.isLoggedIn());
    const isSpacePost = !!space_id;

    useEffect(() => {
        setLikeCount(likes || 0);
    }, [likes]);

    useEffect(() => {
        const onAuth = () => setLikeAuth(authService.isLoggedIn());
        window.addEventListener('userDataChanged', onAuth);
        return () => window.removeEventListener('userDataChanged', onAuth);
    }, []);

    useEffect(() => {
        if (!id) return;
        if (!likeAuth) { setIsLiked(false); return; }
        if (hasLiked !== undefined) { setIsLiked(hasLiked); return; }
        fetch(`/api/has_liked?post_id=${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setIsLiked(data.hasLiked);
                }
            })
            .catch(err => console.error("Error fetching like status:", err));
    }, [id, likeAuth, hasLiked]);

    const handleLike = async (e) => {
        e.stopPropagation();
        try {
            const response = await fetch('/api/like_post', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ postId: id })
            });
            const data = await response.json();
            if (data.success) {
                setIsLiked(data.action === 'liked');
                setLikeCount(data.newFavoriteCount);
            }
        } catch (error) {
            console.error('Like failed:', error);
        }
    };

    const handleClick = () => {
        navigate(`/post?id=${id}`);
    };

    const handleAuthorClick = (e) => {
        e.stopPropagation();
        if (isSpacePost) {
            navigate(`/gig/space/${space_id}`);
        } else {
            navigate(`/profile?userId=${author_id}&item=home`);
        }
    };

    return(
        <>
        <div 
            className="card-row"
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
        >
            {(featured_image || first_image_url) && <img src={API_CONFIG.resolveFileUrl(featured_image || first_image_url)} className="box-article-img" alt="" />}
            <div className="box-col gap10 pd0">
                <div className="box-row pd0">
                    <div className="group-align-left">
                        {isSpacePost ? (
                            space_thumbnail ? (
                                <img
                                    src={API_CONFIG.resolveFileUrl(space_thumbnail)}
                                    className="img-profile-comment"
                                    alt={space_title}
                                    onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }}
                                />
                            ) : (
                                <div className="img-profile-comment" style={{ background: 'var(--color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 13, flexShrink: 0 }}>
                                    {(space_title || 'S').charAt(0).toUpperCase()}
                                </div>
                            )
                        ) : (
                            <img
                                src={author_profile_image ? API_CONFIG.resolveFileUrl(author_profile_image) : API_CONFIG.getDefaultAvatar(author_id)}
                                className="img-profile-comment"
                                alt="Profile"
                                onError={(e) => { e.target.onerror = null; e.target.src = API_CONFIG.getDefaultAvatar(author_id); }}
                            />
                        )}
                        <h4 style={{ cursor: 'pointer' }} onClick={handleAuthorClick}>
                            {isSpacePost ? space_title : author_nickname}
                        </h4>
                        <span style={{ color: 'var(--color-monotone-4)' }}> · {formatPostTimestamp(timestamp)}</span>
                    </div>
                </div>
                <h5>{title}</h5>
                <div className="box-row pd0">
                    <div className="group-align-left">
                        <div className="btn-rtg btn-monotone-1">{category_name || category}</div>
                        <div className="btn-rtg btn-line"><span className="material-symbols-rounded">web_traffic</span> {views || 0}</div>
                        <div 
                            className="btn-rtg btn-line"
                            onClick={handleLike}
                            style={{ 
                                cursor: 'pointer', 
                                color: isLiked ? 'var(--color-failure)' : 'inherit',
                                borderColor: isLiked ? 'var(--color-failure)' : undefined
                            }}
                        >
                        <span className="material-symbols-rounded" style={{color: 'inherit'}}>
                                favorite
                            </span> 
                            {likeCount}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        </>
    )
}

export default CardCommunity;
